import { BackendClient, type BackendTypes } from '@tf/api';

export const monitoringSearchMatchStatusUpdate = async ({
	graphNodeId,
	data,
}: BackendTypes.MonitoringSearchMatchStatusUpdateData): Promise<void> => {
	const res = await BackendClient.getInstance().monitoringSearchMatchStatusUpdate(graphNodeId, data);
};
